(function() {
  "use strict";

  // ===== Config-Elemente einlesen (vom Liquid-Block injiziert) =====

  // Asset-URLs (pro Hüllenfarbe ein Foto-Link)
  const PLBHK_ASSETS = (function() {
    const el = document.getElementById('pl-bhk-assets');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();

  // Konfig-Objekt mit z.B. feeVariantId (Prägezeile-2-Zusatzprodukt)
  const PLBHK_CONFIG = (function() {
    const el = document.getElementById('pl-bhk-config');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();

  // Shopify-Produktdaten inkl. aller Varianten (für Farbe+Ausrichtung-Lookup)
  const PLBHK_PRODUCT = (function() {
    const el = document.getElementById('pl-bhk-product-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  })();

// ===== DATA =====
  // Hex-Werte aus den finalen Photoshop-Hüllen-PNGs gesampelt (Median-of-medians
   // über die Lederfläche). Asset-Keys matchen die JSON-Keys in pl-bhk-assets.
  // Farben aus der Config (Leo: Hell/Dunkel mit Foto ohne + mit Schleife).
  // Fallback: die fest hinterlegten Kieselleder-Farben.
  const colors = (PLBHK_CONFIG.colors && PLBHK_CONFIG.colors.length)
    ? PLBHK_CONFIG.colors.map(function(c) {
        return {
          name: c.name,
          hex: c.hex,
          defaultPhoto: PLBHK_ASSETS[c.photo] || null,
          schleifePhoto: c.schleifePhoto ? (PLBHK_ASSETS[c.schleifePhoto] || null) : null
        };
      })
    : [
        { name: 'Brombeere',      hex: '#6E4D5F', defaultPhoto: PLBHK_ASSETS['brombeere']     || null },
        { name: 'Flieder',        hex: '#7E7185', defaultPhoto: PLBHK_ASSETS['flieder']       || null },
        { name: 'Metallic Grau',  hex: '#4D4946', defaultPhoto: PLBHK_ASSETS['metallic-grau'] || null },
        { name: 'Sage',           hex: '#96917B', defaultPhoto: PLBHK_ASSETS['sage']          || null },
        { name: 'Offwhite',       hex: '#D0CBC3', defaultPhoto: PLBHK_ASSETS['offwhite']      || null },
        { name: 'Rot',            hex: '#6E1322', defaultPhoto: PLBHK_ASSETS['rot']           || null },
        { name: 'Schwarz',        hex: '#352F2B', defaultPhoto: PLBHK_ASSETS['schwarz']       || null },
        { name: 'Rosa',           hex: '#CCA699', defaultPhoto: PLBHK_ASSETS['rosa']          || null },
        { name: 'Dunkelblau',     hex: '#434350', defaultPhoto: PLBHK_ASSETS['dunkelblau']    || null },
        { name: 'Braun',          hex: '#633924', defaultPhoto: PLBHK_ASSETS['braun']         || null },
        { name: 'Beige',          hex: '#988373', defaultPhoto: PLBHK_ASSETS['beige']         || null },
        { name: 'Dunkelgrün',     hex: '#4A4536', defaultPhoto: PLBHK_ASSETS['dunkelgruen']   || null },
      ];

  // Schleifen-Option (Leo/Wildleder): schaltet Häkchen, Foto-Swap und
  // Prägungs-Neuberechnung frei. Geometrie = gemessene Cover-Position im Mit-Schleife-Bild.
  const HAS_SCHLEIFE = !!PLBHK_CONFIG.hasSchleifenOption;
  const SCHLEIFE_GEOM = PLBHK_CONFIG.schleifeGeom || null;
  const VARIANT_SCHEME = PLBHK_CONFIG.variantScheme || 'zeilen';

  // Erlaubte Zeichen inkl. ß und typografischer Anführungszeichen („ = „, " = “).
  // Straight-Quote " bleibt erlaubt und wird in cleanInput zu „ … " umgewandelt.
  const allowedChars = /[A-Z0-9ÄÜÖß!?,.\-;:'&„“" ]/g;

  // ===== Stempel-Inventar (Brass Letter) =====
  // Pro Prägung (Zeile 1 + Zeile 2 zusammen) darf kein Zeichen häufiger vorkommen,
  // als physisch vorhanden ist. Die Drei-Punkte-Gruppe "…" ist ein eigener Stempel
  // (1×), einzelne Punkte "." separat (3×). Diese Liste ist die einzige Quelle für
  // alle Limits — zum Anpassen einfach hier die Zahlen ändern.
  const STOCK = {
    'A':8,'Ä':4,'B':4,'C':4,'D':4,'E':10,'F':4,'G':4,'H':4,'I':6,'J':4,'K':4,
    'L':4,'M':4,'N':8,'O':6,'Ö':4,'P':4,'Q':2,'R':8,'S':6,'ß':2,'T':6,'U':4,
    'Ü':4,'V':2,'W':4,'X':2,'Y':2,'Z':4,
    '0':5,'1':2,'2':3,'3':3,'4':2,'5':2,'6':2,'7':2,'8':2,'9':2,
    "'":1,'.':3,',':2,'&':1,'!':1,'?':1,'„':1,'“':1,':':1,';':1,'…':1,'-':2,' ':8
  };

  // Isolierte 3-Punkt-Gruppe = 1 Stempel ("…"). Lookbehind/-ahead => nur exakt 3er.
  const ELLIPSIS_RE = /(?<![.])\.{3}(?![.])/g;
  const ELLIPSIS_TOKEN = '…';

  function countCharsEffective(text) {
    // Jede isolierte 3-Punkt-Gruppe zählt als ein Zeichen
    return text.replace(ELLIPSIS_RE, '\x01').length;
  }

  function countEllipses(text) {
    const m = text.match(ELLIPSIS_RE);
    return m ? m.length : 0;
  }

  // Verhindert 4+ Punkte hintereinander (optisch falsch), trimmt auf genau 3.
  function clampConsecutiveDots(text) {
    return text.replace(/\.{4,}/g, '...');
  }

  // Zeichen → Anzahl. Isolierte "..." werden als ein "…"-Stempel gezählt,
  // alle übrigen Zeichen einzeln.
  function tallyChars(text) {
    const counts = {};
    const ell = countEllipses(text);
    if (ell) counts[ELLIPSIS_TOKEN] = ell;
    const rest = text.replace(ELLIPSIS_RE, '');
    for (const ch of rest) counts[ch] = (counts[ch] || 0) + 1;
    return counts;
  }

  function combineTally(a, b) {
    const out = Object.assign({}, a);
    for (const k in b) out[k] = (out[k] || 0) + b[k];
    return out;
  }

  // Erstes Zeichen, dessen Bestand (text + otherText zusammen) überschritten ist.
  function findOverflowChar(text, otherText) {
    const total = combineTally(tallyChars(text), tallyChars(otherText || ''));
    for (const ch in total) {
      const limit = STOCK[ch];
      if (limit !== undefined && total[ch] > limit) return ch;
    }
    return null;
  }

  // Mitzählende andere Zeile (gemeinsames Stempel-Budget):
  // horizontal mit aufgeklappter 2. Zeile => beide Zeilen teilen sich den Bestand.
  function budgetOtherLine(editingLine1) {
    if (state.orientation === 'horizontal' && state.line2Expanded) {
      return editingLine1 ? state.line2 : state.line1;
    }
    return editingLine1 ? '' : state.line1;
  }

  // Nach Layoutwechsel (z.B. zurück auf horizontal) Zeile 2 gegen den Bestand prüfen.
  function revalidateStock() {
    if (state.orientation === 'horizontal' && state.line2Expanded) {
      while (state.line2.length > 0 && findOverflowChar(state.line2, state.line1)) {
        state.line2 = state.line2.substring(0, state.line2.length - 1);
      }
      if (line2Input && line2Input.value !== state.line2) line2Input.value = state.line2;
    }
  }

  // Zahlwörter (max. Bestand ist 10), für die Hinweis-Texte ausgeschrieben.
  const NUM_WORDS = {1:'ein',2:'zwei',3:'drei',4:'vier',5:'fünf',6:'sechs',7:'sieben',8:'acht',9:'neun',10:'zehn'};

  // Bezeichnungen für Sonderzeichen (Singular/Plural). Buchstaben und Ziffern
  // nutzen direkt das Zeichen selbst.
  const CHAR_NOUNS = {
    '&': {s:'&-Zeichen', p:'&-Zeichen'},
    ',': {s:'Komma', p:'Kommata'},
    '.': {s:'Punkt', p:'Punkte'},
    '-': {s:'Bindestrich', p:'Bindestriche'},
    ';': {s:'Semikolon', p:'Semikolons'},
    ':': {s:'Doppelpunkt', p:'Doppelpunkte'},
    "'": {s:'Apostroph', p:'Apostrophe'},
    '!': {s:'Ausrufezeichen', p:'Ausrufezeichen'},
    '?': {s:'Fragezeichen', p:'Fragezeichen'},
    '„': {s:'Anführungszeichen unten', p:'Anführungszeichen unten'},
    '“': {s:'Anführungszeichen oben', p:'Anführungszeichen oben'},
    ' ': {s:'Leerzeichen', p:'Leerzeichen'}
  };

  // Kurzer Aufklär-Hinweis (Badge): "<u>Anzahl</u> Bezeichnung pro Prägung möglich".
  // Bewusst ohne Satzzeichen am Ende; die Zahl wird unterstrichen.
  function stockWarning(ch) {
    if (ch === ELLIPSIS_TOKEN) {
      return 'Maximal <u>eine</u> Drei-Punkte-Gruppe pro Prägung möglich';
    }
    const limit = STOCK[ch];
    const word = NUM_WORDS[limit] || String(limit);
    const noun = CHAR_NOUNS[ch] ? (limit === 1 ? CHAR_NOUNS[ch].s : CHAR_NOUNS[ch].p) : ch;
    return 'Maximal <u>' + word + '</u> ' + noun + ' pro Prägung möglich';
  }

  // Wandelt Straight-Quotes (und typografische) in alternierende „ … " um.
  function smartQuotes(s) {
    let open = true, out = '';
    for (const ch of s) {
      if (ch === '"' || ch === '„' || ch === '“') {
        out += open ? '„' : '“';
        open = !open;
      } else {
        out += ch;
      }
    }
    return out;
  }

  // Preise
  const BASE_PRICE = 39.90;
  const LINE2_SURCHARGE = 7.00;

  const state = {
    colorIndex: 0, // erste Farbe (Leo: Hell)
    orientation: 'horizontal',
    foil: 'gold',
    schleife: false,
    line1: '',
    line2: '',
    line2Expanded: false,
    lastEllipsisCount: 0  // Tracking für Badge-Trigger (0 → 1 = Badge zeigen)
  };

  function formatPrice(value) {
    return value.toFixed(2).replace('.', ',') + ' €';
  }

  // Photo storage (pro Farbe, im Speicher während der Session)
  const photos = {};

  // ===== DOM =====
  const coverEl       = document.getElementById('cover');
  const embossingEl   = document.getElementById('embossing');
  const swatchesEl    = document.getElementById('swatches');
  const line1Input    = document.getElementById('line1');
  const line2Input    = document.getElementById('line2');
  const line1Count    = document.getElementById('line1Count');
  const line2Count    = document.getElementById('line2Count');
  const line2Block    = document.getElementById('line2Block');
  const summaryContent = document.getElementById('summaryContent');
  const orientationBtns = document.getElementById('orientationBtns');
  const foilBtns      = document.getElementById('foilBtns');
  const photoInput    = document.getElementById('photoInput');
  const photoInfo     = document.getElementById('photoInfo');
  const removePhoto   = document.getElementById('removePhoto');
  const previewWrapper = document.getElementById('previewWrapper');
  const addLine2Btn   = document.getElementById('addLine2Btn');
  const line2Expanded = document.getElementById('line2Expanded');
  const removeLine2Btn = document.getElementById('removeLine2Btn');
  const verticalHint  = document.getElementById('verticalHint');
  const heroPrice     = document.getElementById('heroPrice');
  const coverArea     = document.getElementById('coverArea');
  const embossHint    = document.getElementById('embossHint');
  const schleifeToggle = document.getElementById('schleifeToggle');
  const line2PriceTag = document.querySelector('.pl-bhk .price-tag');
  const line2PriceReminder = document.querySelector('.pl-bhk .price-reminder');

  let lastPriceShown = null;

  // ===== Varianten-Daten: Preis + Vergleichspreis je Kombination =====
  // Quelle ist Shopify (product | json, Preise in Cent). Rabatt = Vergleichspreis > Preis.
  // Streichpreis und "%"-Badge erscheinen damit automatisch, sobald in Shopify ein
  // Vergleichspreis gesetzt ist, und verschwinden, wenn er wieder entfernt wird.
  const variantMap = {};
  const DISCOUNT_COLORS = new Set();
  if (PLBHK_PRODUCT && Array.isArray(PLBHK_PRODUCT.variants)) {
    PLBHK_PRODUCT.variants.forEach(function(v) {
      const key = v.option1 + '|' + v.option2 + '|' + v.option3;
      const price = v.price / 100;
      const compareAt = v.compare_at_price ? v.compare_at_price / 100 : null;
      variantMap[key] = { id: v.id, price: price, compareAt: compareAt };
      if (compareAt && compareAt > price) DISCOUNT_COLORS.add(v.option1);
    });
  }

  // ===== Render swatches =====
  // Rabattierte Farben bekommen ein "%"-Badge und einen roten Ring.
  colors.forEach((c, i) => {
    const wrap = document.createElement('div');
    wrap.className = 'swatch-wrap' + (i === state.colorIndex ? ' active' : '');
    wrap.dataset.index = i;
    const discounted = DISCOUNT_COLORS.has(c.name);
    wrap.innerHTML = `
      <div class="swatch${discounted ? ' discount' : ''}" style="background:${c.hex}">${discounted ? '<span class="swatch-badge" aria-label="reduziert">%</span>' : ''}</div>
      <div class="swatch-label">${c.name}</div>
    `;
    wrap.addEventListener('click', () => selectColor(i));
    swatchesEl.appendChild(wrap);
  });

  function selectColor(i) {
    state.colorIndex = i;
    document.querySelectorAll('.swatch-wrap').forEach((el, idx) => {
      el.classList.toggle('active', idx === i);
    });
    render();
  }

  // Feld-Label über Zeile 1 an die Ausrichtung anpassen (klarer für Laien):
  // horizontal = "Zeile 1 · bis zu 7 Zeichen", vertikal = "Prägung · bis zu 12 Zeichen".
  function updateLine1Label() {
    const lbl = document.getElementById('line1Label');
    if (!lbl) return;
    if (state.orientation === 'vertical') {
      lbl.innerHTML = 'Prägung <span class="label-hint">· bis zu 12 Zeichen</span>';
    } else {
      lbl.innerHTML = 'Zeile 1 <span class="label-hint">· bis zu 7 Zeichen</span>';
    }
  }

  // ===== Zeile 2 – aufklappen / schließen =====
  function updateLine2UI() {
    updateLine1Label();
    if (state.orientation === 'vertical') {
      line2Block.style.display = 'none';
      verticalHint.style.display = '';
      return;
    }
    line2Block.style.display = '';
    verticalHint.style.display = 'none';
    if (state.line2Expanded) {
      addLine2Btn.style.display = 'none';
      line2Expanded.style.display = '';
    } else {
      addLine2Btn.style.display = '';
      line2Expanded.style.display = 'none';
    }
  }

  addLine2Btn.addEventListener('click', () => {
    state.line2Expanded = true;
    updateLine2UI();
    setTimeout(() => line2Input.focus(), 40);
  });

  removeLine2Btn.addEventListener('click', () => {
    state.line2Expanded = false;
    state.line2 = '';
    line2Input.value = '';
    updateCounts();
    updateLine2UI();
    render();
  });

  // Einmaliges Aufleuchten des Vorschaufelds beim Wechsel der Ausrichtung.
  // Nur wenn noch keine Prägung sichtbar ist (sonst läge das Feld über dem Text).
  function flashEmbossHint() {
    if (!embossHint) return;
    const hasText = state.line1.trim().length > 0
      || (state.orientation === 'horizontal' && state.line2.trim().length > 0);
    if (hasText) return;
    embossHint.classList.remove('flash');
    embossHint.className = 'emboss-hint ' + state.orientation;
    void embossHint.offsetWidth; // Reflow erzwingen, damit die Animation neu startet
    embossHint.classList.add('flash');
  }
  if (embossHint) {
    embossHint.addEventListener('animationend', function() {
      embossHint.classList.remove('flash');
    });
  }

  // ===== Orientation =====
  orientationBtns.addEventListener('click', e => {
    const btn = e.target.closest('[data-orientation]');
    if (!btn) return;
    state.orientation = btn.dataset.orientation;
    orientationBtns.querySelectorAll('.option-btn').forEach(b => {
      b.classList.toggle('active', b.dataset.orientation === state.orientation);
    });
    // maxLength = effektives Limit + Reserve für die Ellipsen-Ersparnis
    // (3 raw chars → 1 effektives = 2 Zeichen Reserve)
    if (state.orientation === 'vertical') {
      line1Input.maxLength = 14;  // 12 effektiv + 2 Ellipsen-Reserve
      // Zeile-2-Zustand bleibt erhalten, wird nur ausgeblendet.
    } else {
      line1Input.maxLength = 9;   // 7 effektiv + 2 Ellipsen-Reserve
      // Smart-Truncate: kürze raw chars vom Ende solange effektive Länge > 7
      while (state.line1.length > 0 && countCharsEffective(state.line1) > 7) {
        state.line1 = state.line1.substring(0, state.line1.length - 1);
      }
      if (line1Input.value !== state.line1) line1Input.value = state.line1;
    }
    // Nach Wechsel zurück auf horizontal kann Zeile 2 wieder ins gemeinsame
    // Stempel-Budget fallen — ggf. überzählige Zeichen aus Zeile 2 entfernen.
    revalidateStock();
    updateLine2UI();
    updateCounts();
    render();
    flashEmbossHint();
  });

  // ===== Foil =====
  foilBtns.addEventListener('click', e => {
    const btn = e.target.closest('[data-foil]');
    if (!btn) return;
    state.foil = btn.dataset.foil;
    foilBtns.querySelectorAll('.option-btn').forEach(b => {
      b.classList.toggle('active', b.dataset.foil === state.foil);
    });
    render();
  });

  // ===== Verschluss-Schleife =====
  if (schleifeToggle) {
    if (HAS_SCHLEIFE) {
      schleifeToggle.addEventListener('click', function() {
        state.schleife = !state.schleife;
        schleifeToggle.setAttribute('aria-pressed', state.schleife ? 'true' : 'false');
        render();
        setTimeout(syncNativeVariant, 0);
      });
    } else {
      const grp = schleifeToggle.closest('.control-group');
      if (grp) grp.style.display = 'none';
    }
  }

  // Cover-Geometrie für den Foto-Swap: im Schleifen-Zustand sitzt die Hülle links
  // im breiteren Bild, also den Prägungs-Container auf die Cover-Teilfläche setzen.
  // Dadurch bleiben alle Prägungs-Prozente unverändert und stimmen automatisch.
  function applyCoverGeometry(on) {
    if (on && SCHLEIFE_GEOM && coverArea) {
      const g = SCHLEIFE_GEOM;
      coverEl.style.aspectRatio = String(g.imageAspect);
      coverArea.style.left   = (g.coverLeft * 100) + '%';
      coverArea.style.top    = (g.coverTop * 100) + '%';
      coverArea.style.width  = ((g.coverRight - g.coverLeft) * 100) + '%';
      coverArea.style.height = ((g.coverBottom - g.coverTop) * 100) + '%';
    } else {
      coverEl.style.aspectRatio = '';
      if (coverArea) {
        coverArea.style.left = '';
        coverArea.style.top = '';
        coverArea.style.width = '';
        coverArea.style.height = '';
      }
    }
  }

  // option3-Werte (Ausführung bzw. Zeilenanzahl) je nach Schema + Schleifen-Zustand.
  function ausfPair() {
    if (VARIANT_SCHEME === 'ausfuehrung') {
      return state.schleife
        ? { basis: '+ Schleife', long: '+ 2. Zeile o. lange Prägung + Schleife' }
        : { basis: 'Basis', long: '+ 2. Zeile o. lange Prägung' };
    }
    return { basis: '1 Zeile', long: '2 Zeilen' };
  }

  // ===== Text input =====
  function cleanInput(str) {
    // ß/ẞ vor toUpperCase schützen, sonst macht JS daraus "SS".
    const protectedStr = str.replace(/[ßẞ]/g, '\x00');
    const up = protectedStr.toUpperCase().replace(/\x00/g, 'ß');
    const matched = up.match(allowedChars);
    let cleaned = matched ? matched.join('') : '';
    return smartQuotes(cleaned);
  }

  line1Input.addEventListener('input', e => {
    let cleaned = cleanInput(e.target.value);
    let warnMsg = null;

    // Hard-Stop A: nie 4+ Punkte hintereinander — auf 3 (= eine "…") trimmen
    const beforeDots = cleaned;
    cleaned = clampConsecutiveDots(cleaned);
    if (cleaned !== beforeDots) warnMsg = 'Maximal <u>drei</u> Punkte hintereinander möglich';

    // Hard-Stop B: effektive Zeichenzahl ≤ Limit (… zählt als 1)
    const maxEff1 = state.orientation === 'vertical' ? 12 : 7;
    while (cleaned.length > 0 && countCharsEffective(cleaned) > maxEff1) {
      cleaned = cleaned.substring(0, cleaned.length - 1);
    }

    // Hard-Stop C: Stempel-Inventar (cross-line mit Zeile 2, falls aktiv)
    const otherLine = budgetOtherLine(true);
    let overflowChar = null;
    while (cleaned.length > 0) {
      const oc = findOverflowChar(cleaned, otherLine);
      if (!oc) break;
      overflowChar = oc;
      cleaned = cleaned.substring(0, cleaned.length - 1);
    }
    if (overflowChar) warnMsg = stockWarning(overflowChar);

    if (cleaned !== e.target.value) e.target.value = cleaned;
    state.line1 = cleaned;
    // Pflichtfeld-Fehler ausblenden, sobald Nutzer tippt
    if (cleaned.trim().length > 0) {
      hideLine1Error();
    }

    // Warning hat Priorität über das positive Ellipsen-Badge
    state.suppressEllipsisBadge = !!warnMsg;
    if (warnMsg) showLimitWarning(warnMsg);

    updateCounts();
    render();
  });

  function showLine1Error() {
    const error = document.getElementById('line1Error');
    const block = line1Input.closest('.input-block');
    if (error) error.style.display = '';
    if (block) block.classList.add('has-error');
  }

  function hideLine1Error() {
    const error = document.getElementById('line1Error');
    const block = line1Input.closest('.input-block');
    if (error) error.style.display = 'none';
    if (block) block.classList.remove('has-error');
  }

  line2Input.addEventListener('input', e => {
    let cleaned = cleanInput(e.target.value);
    let warnMsg = null;

    // Hard-Stop A: nie 4+ Punkte hintereinander — auf 3 trimmen
    const beforeDots = cleaned;
    cleaned = clampConsecutiveDots(cleaned);
    if (cleaned !== beforeDots) warnMsg = 'Maximal <u>drei</u> Punkte hintereinander möglich';

    // Hard-Stop B: effektive 7 Zeichen (Zeile 2 ist immer horizontaler Kontext)
    while (cleaned.length > 0 && countCharsEffective(cleaned) > 7) {
      cleaned = cleaned.substring(0, cleaned.length - 1);
    }

    // Hard-Stop C: Stempel-Inventar (cross-line mit Zeile 1)
    const otherLine = budgetOtherLine(false);
    let overflowChar = null;
    while (cleaned.length > 0) {
      const oc = findOverflowChar(cleaned, otherLine);
      if (!oc) break;
      overflowChar = oc;
      cleaned = cleaned.substring(0, cleaned.length - 1);
    }
    if (overflowChar) warnMsg = stockWarning(overflowChar);

    if (cleaned !== e.target.value) e.target.value = cleaned;
    state.line2 = cleaned;

    state.suppressEllipsisBadge = !!warnMsg;
    if (warnMsg) showLimitWarning(warnMsg);

    updateCounts();
    render();
  });

  function updateCounts() {
    const max1 = state.orientation === 'vertical' ? 12 : 7;
    const max2 = 7;

    // Effektive Länge (Ellipsen-Regel: ... = 1 Zeichen)
    const eff1 = countCharsEffective(state.line1);
    const eff2 = countCharsEffective(state.line2);
    const e1   = countEllipses(state.line1);
    const e2   = countEllipses(state.line2);
    const eTotal = e1 + e2;

    line1Count.textContent = `${eff1}/${max1}`;
    line1Count.classList.toggle('has-ellipsis', e1 > 0);

    line2Count.textContent = `${eff2}/${max2}`;
    line2Count.classList.toggle('has-ellipsis', e2 > 0);
    // .limit (rot) wird NICHT mehr gesetzt — dank Hard-Stop kann der Counter
    // nie über das Limit hinaus, daher ist eine "rote Warnung bei 7/7" hinfällig.
    // Counter bleibt im normalen muted-Farbton, bzw. wird Sage-grün wenn eine
    // Ellipse aktiv ist (via .has-ellipsis).

    // Positives Ellipsen-Badge nur zeigen wenn neue Ellipse hinzugekommen ist (0 → 1)
    // UND in derselben Eingabe kein Warning-Badge gefeuert hat (Warning hat Priorität)
    if (eTotal === 1 && state.lastEllipsisCount === 0 && !state.suppressEllipsisBadge) {
      showEllipsisBadge();
    }
    state.lastEllipsisCount = eTotal;
    state.suppressEllipsisBadge = false;  // reset für nächste Eingabe

    // Multi-Ellipsen-Fehler (max 1 ... pro Produkt)
    toggleMultiEllipsisError(eTotal > 1, e1, e2);
  }

  // Universelles Badge — zeigt entweder positive Ellipsen-Bestätigung (sage)
  // oder eine Warnung (amber). Dynamischer Inhalt, dynamische Farbe.
  function showBadge(html, type) {
    // type: 'info' (sage-grün, positive Bestätigung) oder 'warning' (amber, Hard-Stop)
    const badge = document.getElementById('ellipsisBadge');
    if (!badge) return;
    badge.innerHTML = html;
    badge.classList.remove('badge-info', 'badge-warning');
    badge.classList.add('badge-' + type, 'visible');
    clearTimeout(badge._timer);
    badge._timer = setTimeout(() => badge.classList.remove('visible'), 3500);
  }

  function showEllipsisBadge() {
    showBadge('Drei Punkte hintereinander <code>...</code> zählen als ein Zeichen ✨', 'info');
  }

  function showLimitWarning(html) {
    // In ein einzelnes Element packen, damit das <u> nicht zu einem eigenen
    // Flex-Item wird (sonst käme der 6px-Badge-Gap zusätzlich zum Leerzeichen).
    showBadge('<span class="badge-text">' + html + '</span>', 'warning');
  }

  function toggleMultiEllipsisError(show, e1Count, e2Count) {
    const error = document.getElementById('ellipsisError');
    if (error) error.style.display = show ? '' : 'none';
    const block1 = line1Input.closest('.input-block');
    const block2 = line2Input ? line2Input.closest('.input-block') : null;
    if (block1) block1.classList.toggle('has-error', show && e1Count > 0);
    if (block2) block2.classList.toggle('has-error', show && e2Count > 0);
  }

  function hasMultiEllipsisError() {
    return countEllipses(state.line1) + countEllipses(state.line2) > 1;
  }

  // Sicherheitsnetz: prüft die tatsächlich geprägten Zeilen gegen das Inventar.
  function hasStockOverflow() {
    const useLine2 = state.orientation === 'horizontal'
      && state.line2Expanded
      && state.line2.trim().length > 0;
    const combined = combineTally(
      tallyChars(state.line1),
      useLine2 ? tallyChars(state.line2) : {}
    );
    for (const ch in combined) {
      const limit = STOCK[ch];
      if (limit !== undefined && combined[ch] > limit) return true;
    }
    return false;
  }

  function escapeHTML(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // ===== Photo handling =====
  function handlePhotoFile(file) {
    if (!file || !file.type.startsWith('image/')) return;
    const reader = new FileReader();
    reader.onload = e => {
      photos[state.colorIndex] = e.target.result;
      updateSwatchMarkers();
      render();
    };
    reader.readAsDataURL(file);
  }

  photoInput.addEventListener('change', e => {
    const file = e.target.files && e.target.files[0];
    if (file) handlePhotoFile(file);
    photoInput.value = ''; // erlaubt dieselbe Datei erneut zu wählen
  });

  removePhoto.addEventListener('click', () => {
    delete photos[state.colorIndex];
    updateSwatchMarkers();
    render();
  });

  // Drag & Drop auf Preview
  ['dragenter', 'dragover'].forEach(ev => {
    previewWrapper.addEventListener(ev, e => {
      e.preventDefault();
      previewWrapper.classList.add('drag-over');
    });
  });
  ['dragleave', 'drop'].forEach(ev => {
    previewWrapper.addEventListener(ev, e => {
      e.preventDefault();
      if (ev === 'dragleave' && e.target !== previewWrapper) return;
      previewWrapper.classList.remove('drag-over');
    });
  });
  previewWrapper.addEventListener('drop', e => {
    e.preventDefault();
    const file = e.dataTransfer.files && e.dataTransfer.files[0];
    if (file) handlePhotoFile(file);
  });

  function resolvePhoto(idx) {
    return photos[idx] || colors[idx].defaultPhoto || null;
  }

  function updateSwatchMarkers() {
    document.querySelectorAll('.swatch-wrap').forEach((el, idx) => {
      const sw = el.querySelector('.swatch');
      sw.classList.toggle('has-photo', !!resolvePhoto(idx));
    });
  }

  // Aufpreis für Zeile 2 und den Vertikal-Hinweis aus den echten Varianten-Preisen
  // ableiten, damit beide bei rabattierten Farben automatisch stimmen.
  function updatePricingLabels() {
    const colorName = colors[state.colorIndex].name;
    const get = (o, l) => variantMap[colorName + '|' + o + '|' + l] || null;
    const ap = ausfPair();

    // Horizontal: Aufpreis 2. Zeile = Preis(lang) − Preis(basis), im aktuellen Schleifen-Zustand
    const h1 = get('Horizontal', ap.basis);
    const h2 = get('Horizontal', ap.long);
    if (h1 && h2) {
      const now = h2.price - h1.price;
      const discounted = h1.compareAt && h2.compareAt;
      if (discounted) {
        const orig = h2.compareAt - h1.compareAt;
        if (line2PriceTag) line2PriceTag.innerHTML = `<span class="tag-strike">+${formatPrice(orig)}</span>+${formatPrice(now)}`;
        if (line2PriceReminder) line2PriceReminder.innerHTML = `<span class="tag-strike">+ ${formatPrice(orig)}</span> + ${formatPrice(now)} Aufpreis`;
      } else {
        if (line2PriceTag) line2PriceTag.textContent = `+${formatPrice(now)}`;
        if (line2PriceReminder) line2PriceReminder.textContent = `+ ${formatPrice(now)} Aufpreis`;
      }
    }

    // Vertikal-Hinweis: Preise für ≤7 und >7 Zeichen dynamisch einsetzen.
    // Option3-Werte dieses Schemas: "Basis" / "+ 2. Zeile o. lange Prägung"
    // (Fallback auf die alten "1 Zeile"/"2 Zeilen").
    if (verticalHint) {
      const v1 = get('Vertikal', 'Basis') || get('Vertikal', '1 Zeile');
      const v2 = get('Vertikal', '+ 2. Zeile o. lange Prägung') || get('Vertikal', '2 Zeilen');
      const span = verticalHint.querySelector('span');
      if (span && v1 && v2) {
        span.innerHTML = `Bei vertikaler Prägung ist maschinenbedingt nur eine Zeile mit bis zu 12 Zeichen möglich. Bis zu 7 Zeichen sind im Preis von ${formatPrice(v1.price)} enthalten, ab dem 8. Zeichen liegt der Preis bei ${formatPrice(v2.price)}.`;
      }
    }
  }

  // ===== Render =====
  function render() {
    const color = colors[state.colorIndex];
    const userPhoto = photos[state.colorIndex];
    const useSchleife = state.schleife && !!color.schleifePhoto;
    const basePhoto = useSchleife ? color.schleifePhoto : color.defaultPhoto;
    const photo = userPhoto || basePhoto;

    // Foto-Swap: im Schleifen-Zustand auf die Cover-Teilfläche umrechnen (Prägung wandert mit)
    applyCoverGeometry(useSchleife && !userPhoto);

    if (photo) {
      const safeUrl = userPhoto ? photo : encodeURI(photo);
      // Bei transparenten PNG/WebP zeigen die freigestellten Ecken durch — keine hex-Füllung dahinter
      coverEl.style.background = `url("${safeUrl}") center / contain no-repeat transparent`;
      coverEl.classList.add('has-photo');
      if (userPhoto) {
        photoInfo.textContent = 'Eigenes Foto aktiv';
        removePhoto.style.display = '';
      } else {
        photoInfo.textContent = 'Standard-Foto geladen';
        removePhoto.style.display = 'none';
      }
    } else {
      coverEl.style.background = color.hex;
      coverEl.classList.remove('has-photo');
      photoInfo.textContent = 'Foto auf Vorschau ziehen oder Button nutzen';
      removePhoto.style.display = 'none';
    }

    // Text content
    let lines;
    if (state.orientation === 'vertical') {
      lines = state.line1 ? [state.line1] : [];
    } else {
      lines = [state.line1, state.line2].filter(l => l.length > 0);
    }
    // Ellipsen (...) bekommen ein eigenes Inner-Span für engeres Letter-Spacing —
    // damit sie in der Vorschau visuell als zusammengehörige Einheit wirken
    // (spiegelt den physischen Brass-Letter-Stempel).
    function renderLineWithEllipsis(l) {
      const escaped = escapeHTML(l);
      return escaped.replace(/(?<![.])\.{3}(?![.])/g, '<span class="ellipsis-glyph">...</span>');
    }
    embossingEl.innerHTML = lines
      .map(l => `<span class="line foil-${state.foil}">${renderLineWithEllipsis(l)}</span>`)
      .join('');

    // Orientation class auf dem Container; Folie auf der Zeile
    embossingEl.className = `embossing ${state.orientation}`;

    // Summary
    const foilName = { gold: 'Gold', silver: 'Silber', blind: 'Blindprägung' }[state.foil];
    const orientName = state.orientation === 'horizontal' ? 'Horizontal' : 'Vertikal';
    const textDisplay = lines.length ? lines.join(' / ') : '—';

    // Preis kommt direkt aus der gewählten Shopify-Variante (Aufpreis für 2. Zeile
    // bzw. langen Vertikaltext steckt bereits in der Variante). Vergleichspreis > Preis = Rabatt.
    const variant = getCurrentVariant();
    const hasPaidUpgrade = shouldChargeUpgrade();
    const price = variant ? variant.price : (BASE_PRICE + (hasPaidUpgrade ? LINE2_SURCHARGE : 0));
    const compareAt = variant ? variant.compareAt : null;
    const isDiscounted = compareAt && compareAt > price;
    const discountPct = isDiscounted ? Math.round((compareAt - price) / compareAt * 100) : 0;

    let breakdownNote = '';
    if (hasPaidUpgrade) {
      if (state.orientation === 'horizontal') {
        breakdownNote = `<div class="summary-breakdown">Buchhülle inklusive Mehrkosten für 2. Prägezeile</div>`;
      } else {
        breakdownNote = `<div class="summary-breakdown">Buchhülle inklusive Mehrkosten für längere Prägung (über 7 Zeichen)</div>`;
      }
    }

    // Bestehende Kompatibilität für die Folgelogik
    const hasPaidLine2 = state.orientation === 'horizontal'
      && state.line2Expanded
      && state.line2.length > 0;

    // Prägung aufschlüsseln in Zeile 1 und (optional) Zeile 2
    const line1Value = state.line1.length > 0 ? escapeHTML(state.line1) : '—';
    const line2Row = hasPaidLine2
      ? `<div class="summary-row"><span>Prägung Zeile 2</span><strong>${escapeHTML(state.line2)}</strong></div>`
      : '';

    summaryContent.innerHTML = `
      <div class="summary-row"><span>Buchhüllenfarbe</span><strong>${color.name}</strong></div>
      <div class="summary-row"><span>Ausrichtung</span><strong>${orientName}</strong></div>
      <div class="summary-row"><span>Farbe der Prägung</span><strong>${foilName}</strong></div>
      ${HAS_SCHLEIFE ? `<div class="summary-row"><span>Verschluss-Schleife</span><strong>${state.schleife ? 'Ja' : 'Nein'}</strong></div>` : ''}
      <div class="summary-row"><span>Prägung Zeile 1</span><strong>${line1Value}</strong></div>
      ${line2Row}
      <div class="summary-divider"></div>
      <div class="summary-row summary-total"><strong>Gesamtpreis</strong><strong>${isDiscounted ? `<span class="summary-strike">${formatPrice(compareAt)}</span><span class="summary-now">${formatPrice(price)}</span>` : formatPrice(price)}</strong></div>
      ${breakdownNote}
    `;

    // Hero-Preis oben: bei Rabatt "−X %"-Pill + Streichpreis + roter Preis,
    // sonst nur der Preis. Kleines Pulsieren bei Änderung.
    const heroHTML = isDiscounted
      ? `<span class="hero-pill">−${discountPct} %</span><span class="hero-strike">${formatPrice(compareAt)}</span><span class="hero-now">${formatPrice(price)}</span>`
      : formatPrice(price);
    heroPrice.innerHTML = heroHTML;
    if (lastPriceShown !== null && lastPriceShown !== heroHTML) {
      heroPrice.classList.remove('pulse');
      void heroPrice.offsetWidth; // Reflow erzwingen, damit die Animation neu startet
      heroPrice.classList.add('pulse');
      setTimeout(() => heroPrice.classList.remove('pulse'), 260);
    }
    lastPriceShown = heroHTML;

    updatePricingLabels();
    syncNativeVariant();
  }

  updateCounts();
  updateSwatchMarkers();
  updateLine2UI();
  render();

  // ======================================================================
  // ETAPPE 2: Cart-Integration mit Shopify-Varianten
  // ======================================================================

  // Varianten-Map (id + Preis + Vergleichspreis) wird bereits oben aufgebaut,
  // damit schon der erste Render den korrekten Preis und Rabattstatus kennt.

  // Schwelle ab der bei vertikaler Prägung der höhere Preis (46,90 €) gilt
  const VERTICAL_UPGRADE_THRESHOLD = 7;

  function shouldChargeUpgrade() {
    // Höherer Preis greift bei:
    // - Horizontal: zweite Zeile aufgeklappt UND befüllt
    // - Vertikal: mehr als 7 EFFEKTIVE Zeichen in der einen Zeile
    //   (Ellipsen-Regel: "..." zählt als 1 Zeichen, nicht als 3)
    if (state.orientation === 'horizontal') {
      return state.line2Expanded && state.line2.trim().length > 0;
    }
    return countCharsEffective(state.line1.trim()) > VERTICAL_UPGRADE_THRESHOLD;
  }

  // option3-Wert (Ausführung bzw. Zeilenanzahl) der aktuellen Auswahl.
  function getCurrentOption3() {
    const p = ausfPair();
    return shouldChargeUpgrade() ? p.long : p.basis;
  }

  function getCurrentVariant() {
    const color = colors[state.colorIndex].name;
    const orientDE = state.orientation === 'horizontal' ? 'Horizontal' : 'Vertikal';
    return variantMap[color + '|' + orientDE + '|' + getCurrentOption3()] || null;
  }

  function getCurrentVariantId() {
    const v = getCurrentVariant();
    return v ? v.id : null;
  }

  // Impacts Produkt-Formular auf der Seite finden (mehrere Strategien, robust)
  function findProductForm() {
    return document.querySelector('.shopify-section--main-product product-form form')
        || document.querySelector('product-form form')
        || document.querySelector('.shopify-section--main-product form[action*="/cart"]')
        || document.querySelector('form[action*="/cart/add"]')
        || (function() {
             const btn = document.querySelector('.shopify-section--main-product [name="add"], .shopify-section--main-product button[type="submit"]');
             return btn ? btn.closest('form') : null;
           })();
  }

  // Versteckte Properties-Inputs (Wunschtext, Folie) verwalten, damit auch Impacts
  // nativer Add-to-Cart die Personalisierung mitschickt.
  function setProp(form, key, value) {
    let input = form.querySelector('input[data-plbhk-prop="' + key + '"]');
    if (!value) { if (input) input.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + key + ']';
      input.setAttribute('data-plbhk-prop', key);
      form.appendChild(input);
    }
    input.value = value;
  }

  // Varianten-ID UND Präge-Eigenschaften IMMER ins Formular schreiben. So fügt auch
  // Impacts eigener Add-to-Cart (Button-Klick statt Form-Submit) garantiert die
  // richtige Variante mit korrektem Wunschtext und Folie hinzu.
  function syncNativeVariant() {
    const form = findProductForm();
    if (!form) return;

    const variantId = getCurrentVariantId();
    if (variantId) {
      let idInput = form.querySelector('input[name="id"], select[name="id"]');
      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        form.appendChild(idInput);
      }
      if (String(idInput.value) !== String(variantId)) {
        idInput.value = variantId;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const orientName = state.orientation === 'horizontal' ? 'Horizontal' : 'Vertikal';
    const foilName = { gold: 'Gold', silver: 'Silber', blind: 'Blindprägung' }[state.foil];
    setProp(form, 'Ausrichtung', orientName);
    setProp(form, 'Farbe der Prägung', foilName);
    setProp(form, 'Prägung Zeile 1', state.line1.trim() ? state.line1 : null);
    const hasLine2 = state.orientation === 'horizontal' && state.line2Expanded && state.line2.trim().length > 0;
    setProp(form, 'Prägung Zeile 2', hasLine2 ? state.line2 : null);
  }

  // Nach Klicks, die den Konfigurator-State ändern, die versteckte Variante mitziehen
  function hookStateSync() {
    // Nach jedem Klick auf Swatch oder Ausrichtungs-Button die Variante mitziehen
    document.querySelectorAll('.pl-bhk .swatch-wrap').forEach(function(el) {
      el.addEventListener('click', function() { setTimeout(syncNativeVariant, 0); });
    });
    const orientBtns = document.getElementById('orientationBtns');
    if (orientBtns) {
      orientBtns.addEventListener('click', function() { setTimeout(syncNativeVariant, 0); });
    }
  }

  // Add-to-Cart-Formular abfangen und selbst die Cart-API bedienen
  function setupCartHook() {
    const form = findProductForm();
    if (!form) return;

    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      e.stopPropagation();

      const variantId = getCurrentVariantId();
      if (!variantId) {
        alert('Diese Farb-/Ausrichtungs-Kombination ist aktuell nicht verfügbar.');
        return;
      }

      // Pflichtfeld-Check: Zeile 1 muss ausgefüllt sein (bei beiden Ausrichtungen)
      if (!state.line1.trim()) {
        showLine1Error();
        line1Input.focus();
        line1Input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // Drei-Punkte-Sonderregel: max 1 Ellipse pro Produkt
      if (hasMultiEllipsisError()) {
        const errorEl = document.getElementById('ellipsisError');
        if (errorEl) errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // Stempel-Inventar: keine Prägung, die den Zeichenbestand übersteigt
      if (hasStockOverflow()) {
        showLimitWarning('Die Prägung überschreitet den verfügbaren Zeichenbestand');
        line1Input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const hasLine2 =
        state.orientation === 'horizontal' &&
        state.line2Expanded &&
        state.line2.trim().length > 0;

      const foilName = { gold: 'Gold', silver: 'Silber', blind: 'Blindprägung' }[state.foil];
      const orientName = state.orientation === 'horizontal' ? 'Horizontal' : 'Vertikal';

      // Haupt-Produkt: Wunschtext + Folie als Line Item Properties.
      // "Ausrichtung" wird nicht als Property mitgeschickt, weil sie bereits in
      // der Variante (Flieder / Horizontal) enthalten ist und sonst doppelt erscheint.
      const mainProperties = {
        'Ausrichtung': orientName,
        'Farbe der Prägung': foilName
      };
      if (state.line1.trim().length > 0) {
        mainProperties['Prägung Zeile 1'] = state.line1;
      }
      if (hasLine2) {
        mainProperties['Prägung Zeile 2'] = state.line2;
      }

      // Nur ein Item: der Aufpreis für die zweite Prägezeile ist jetzt
      // bereits in der gewählten Variante (Zeilenanzahl) enthalten.
      const items = [
        { id: variantId, quantity: 1, properties: mainProperties }
      ];

      // Submit-Button disablen, damit kein Doppelklick doppelten Warenkorb erzeugt
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) {
          const err = await response.json().catch(function() { return {}; });
          alert('Fehler beim Hinzufügen: ' + (err.description || 'Bitte nochmal versuchen.'));
          if (submitBtn) submitBtn.disabled = false;
          return;
        }

        // Cart-Sections per Shopify-API frisch laden, damit der Drawer
        // (und das Cart-Icon-Bubble) den neuen Stand inkl. unserer Vorschau zeigen.
        try {
          const sectionsResponse = await fetch('/?sections=cart-drawer,cart-icon-bubble');
          if (sectionsResponse.ok) {
            const sections = await sectionsResponse.json();

            // Cart-Drawer-Section ersetzen
            if (sections['cart-drawer']) {
              const drawerSection = document.getElementById('shopify-section-cart-drawer');
              if (drawerSection) {
                drawerSection.innerHTML = sections['cart-drawer'];
              }
            }

            // Cart-Icon-Bubble (Zähler oben rechts) aktualisieren
            if (sections['cart-icon-bubble']) {
              const bubbleSection = document.getElementById('shopify-section-cart-icon-bubble');
              if (bubbleSection) {
                bubbleSection.innerHTML = sections['cart-icon-bubble'];
              }
            }
          }
        } catch (sectionErr) {
          console.warn('[pl-bhk] Cart-Sections-Refresh fehlgeschlagen:', sectionErr);
        }

        // Cart-Drawer öffnen – verschiedene API-Pfade probieren
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.show === 'function') {
            cartDrawer.show();
          } else if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            cartDrawer.setAttribute('open', '');
            cartDrawer.dispatchEvent(new CustomEvent('show', { bubbles: true }));
          }
        }

        // Theme-Events für andere Cart-Komponenten dispatchen
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('on:cart:after-add', { bubbles: true }));

        if (submitBtn) submitBtn.disabled = false;

      } catch (err) {
        console.error('[pl-bhk] Cart-Fehler:', err);
        alert('Netzwerkfehler. Bitte Internet checken und nochmal versuchen.');
        if (submitBtn) submitBtn.disabled = false;
      }
    }, true);
  }

  // Initialisierung: bei DOM-Ready (oder sofort, wenn bereits geladen)
  function initCartIntegration() {
    syncNativeVariant();
    hookStateSync();
    setupCartHook();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartIntegration);
  } else {
    initCartIntegration();
  }
})();